import React, { createContext, useState, useEffect } from "react";
import { salvarAvaliacaoAcao } from "../../../../../service/Rag/AvaliacaoAcao";
import { printToast } from "../../../../../config/global";
import { useHistory } from "react-router-dom";
export const AvaliacaoAcaoContext = createContext();

export const AvaliacaoAcaoProvider = ({ children, props }) => {
  const [camposPPDCOFD, setCamposPPDCOFD] = useState(JSON.parse(props.questionarioPPDCOFD));
  const [camposDispFinan, setCamposDispFinan] = useState(JSON.parse(props.questionarioDispFinan));
  const [camposEficiencia, setCamposEficiencia] = useState(JSON.parse(props.questionarioEficiencia));
  const [dadosOrcamFinan, setDadosOrcamFinan] = useState([...props.dadosItemAcao.ptaFiplan.plan72RealizadoAcao]);
  const [totalOrcamFinan, setTotalOrcamFinan] = useState({
    codgFonte: "Total",
    vlrInicial: 0,
    vlrAtualizado: 0,
    vlrSuplementado: 0,
    vlrAnulado: 0,
    vlrContigenciadoBloqueado: 0,
    vlrEmpenhado: 0,
    vlrLiquidado: 0,
    vlrPpd: 0,
    vlrCofd: 0,
    vlrLiquidadoInicial: 0,
    vlrLiquidadoFinal: 0,
    vlrMetaAtualizada:
      props.dadosItemAcao.ptaFiplan.qtdeProdutoInicial != null ? props.dadosItemAcao.ptaFiplan.qtdeProdutoInicial : 0,
    vlrMetaAtualizada:
      props.dadosItemAcao.ptaFiplan.qtdeProdutoPrevisto != null ? props.dadosItemAcao.ptaFiplan.qtdeProdutoPrevisto : 0,
  });
  let history = useHistory();
  useEffect(() => {
    const calcularTotal = () => {
      let total = {
        codgFonte: "Total",
        vlrInicial: dadosOrcamFinan.reduce((acc, current) => acc + parseFloat(current.vlrInicial.toFixed(2)), 0),
        vlrAtualizado: dadosOrcamFinan.reduce((acc, current) => acc + parseFloat(current.vlrAtualizado.toFixed(2)), 0),
        vlrSuplementado: dadosOrcamFinan.reduce(
          (acc, current) => acc + parseFloat(current.vlrSuplementado.toFixed(2)),
          0
        ),
        vlrAnulado: dadosOrcamFinan.reduce((acc, current) => acc + parseFloat(current.vlrAnulado.toFixed(2)), 0),
        vlrContigenciadoBloqueado: dadosOrcamFinan.reduce(
          (acc, current) => acc + parseFloat(current.vlrContigenciadoBloqueado.toFixed(2)),
          0
        ),
        vlrEmpenhado: dadosOrcamFinan.reduce((acc, current) => acc + parseFloat(current.vlrEmpenhado.toFixed(2)), 0),
        vlrLiquidado: dadosOrcamFinan.reduce((acc, current) => acc + parseFloat(current.vlrLiquidado.toFixed(2)), 0),
        vlrPpd: 0,
        vlrCofd: 0,
        vlrLiquidadoInicial: 0,
        vlrLiquidadoFinal: 0,
      };

      let vlrAtualizado = total.vlrAtualizado - total.vlrContigenciadoBloqueado;
      total.vlrPpd = total.vlrInicial !== 0 ? (total.vlrEmpenhado / total.vlrInicial) * 100 : 0;
      total.vlrCofd = vlrAtualizado !== 0 ? (total.vlrEmpenhado / vlrAtualizado) * 100 : 0;
      total.vlrLiquidadoInicial = total.vlrInicial !== 0 ? (total.vlrLiquidado / total.vlrInicial) * 100 : 0;
      total.vlrLiquidadoFinal = total.vlrAtualizado !== 0 ? (total.vlrLiquidado / total.vlrAtualizado) * 100 : 0;

      setTotalOrcamFinan(total);
    };

    calcularTotal();
  }, [dadosOrcamFinan]);
  const voltar = () => {
    history.push({ pathname: "/raglancamentos", state: {} });
  };
  const salvar = () => {
    let jsonCampos = [...camposPPDCOFD, ...camposDispFinan, ...camposEficiencia].map((questao) => {
      questao.valrRespostaItemQuest = questao.data;
      return { ...questao };
    });

    let codigoItem = camposPPDCOFD[0].codigoItemRag;

    salvarAvaliacaoAcao(codigoItem, jsonCampos).then((res) => {
      props.aba(true);  //Controle para sinalizar que a Aba Identificacao deve realizar a busca do percentual de preenchimento do acao
      printToast({ summary: "Ação Efetuada", detail: "Avaliação da Execução salva com sucesso" });
    });
  };
  const setQuestAnaliseAtualizado = (e) => {
    props.setCamposQuestionarioAnalisePpdCofd(JSON.stringify(e));
    setCamposPPDCOFD(e);
  };

  const setQuestDispFinanAtualizado = (e) => {
    props.setCamposQuestionarioDisponibilidade(JSON.stringify(e));
    setCamposDispFinan(e);
  };

  const setQuestEficienciaAtualizado = (e) => {
    props.setCamposQuestionarioEficiencia(JSON.stringify(e));
    setCamposEficiencia(e);
  };

  return (
    <AvaliacaoAcaoContext.Provider
      value={{
        listaProduto: props.dadosItemAcao?.produtoAcao,

        camposPPDCOFD,
        setCamposPPDCOFD,
        camposDispFinan,
        setCamposDispFinan,
        camposEficiencia,
        setCamposEficiencia,
        dadosOrcamFinan,
        totalOrcamFinan,
        setQuestAnaliseAtualizado,
        setQuestEficienciaAtualizado,
        setQuestDispFinanAtualizado,
        salvar,
        voltar,
        condicao: props.condicao,
      }}
    >
      {children}
    </AvaliacaoAcaoContext.Provider>
  );
};
